import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  AFFILIATES_REQUEST_HISTORY_DOWNLOAD_LIST_MUTATION_KEY,
  AFFILIATES_REQUEST_HISTORY_LIST_REPORT_URL,
  AFFILIATES_REQUEST_HISTORY_PERMISSIONS,
} from '../constants';

export default function useDownloadAffiliatesRequestHistoryReportMutation(): IContextMutationResult<
  void,
  Error,
  IDownloadListReportPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [AFFILIATES_REQUEST_HISTORY_DOWNLOAD_LIST_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      AFFILIATES_REQUEST_HISTORY_LIST_REPORT_URL,
      payload,
      { permission: AFFILIATES_REQUEST_HISTORY_PERMISSIONS.DOWNLOAD_LIST },
    ),
  });
}
